import React, { useState } from "react";
import { Box, TextField, Button, Typography, Alert } from "@mui/material";
import emailjs from "@emailjs/browser";
import {styled} from "@mui/material/styles";

export default function ContactForm() {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState(null);
    const CustomButton = styled(Button)({
        backgroundColor: "#b71c1ccf",
        "&:hover": {
            backgroundColor: "#9a1515cf",
        },
    });

    const handleSubmit = (e) => {
        e.preventDefault();

        const templateParams = {
            to_name: "Contact site de la Vitréenne",
            from_email: email,
            message: message,
        };

        emailjs
            .send(
                "service_hjlzqfi", // EmailJS service ID
                "template_qoyuvl7", // EmailJS template ID
                templateParams,
                "QxdZez5gnbEO4spyo" // EmailJS public key
            )
            .then(
                (response) => {
                    setStatus({ type: "success", message: "Message envoyé avec succès !" });
                    setEmail("");
                    setMessage("");
                },
                (error) => {
                    setStatus({ type: "error", message: "Erreur lors de l'envoi. Veuillez réessayer." });
                }
            );
    };

    return (
        <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
                maxWidth: "50%",
                margin: "auto",
                display: "flex",
                flexDirection: "column",
                gap: 2,
                padding: 3,
                boxShadow: 3,
                borderRadius: 2,
                backgroundColor: "white",
            }}
        >
            <Typography variant="h5" sx={{ textAlign: "center" }}>
                Contactez-nous
            </Typography>

            {status && <Alert severity={status.type}>{status.message}</Alert>}

            <TextField
                label="Votre Email"
                type="email"
                fullWidth
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                sx={{
                    "& label.Mui-focused": { color: "#b71c1ccf" }, // Label color on focus
                    "& .MuiOutlinedInput-root": {
                        "&.Mui-focused fieldset": { borderColor: "#b71c1ccf" }, // Border color on focus
                    },
                }}
            />

            <TextField
                label="Votre Message"
                multiline
                rows={10}
                fullWidth
                required
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                sx={{
                    "& label.Mui-focused": { color: "#b71c1ccf" }, // Label color on focus
                    "& .MuiOutlinedInput-root": {
                        "&.Mui-focused fieldset": { borderColor: "#b71c1ccf" }, // Border color on focus
                    },
                }}
            />

            <CustomButton type="submit" variant="contained" color="primary">
                Envoyer
            </CustomButton>
        </Box>
    );
}

